import Vue from "vue";
import { Trace, TRACE_DATA_TYPE_ENUM } from ".";
import { isDev } from '../utils';

const DEV = isDev()

if (!DEV) {
  Vue.config.errorHandler = function (err, vm, info) {
    // handle error
    // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
    // 只在 2.2.0+ 可用
    try {
      Trace(
        { err: err.message || "", info, api: "Vue.config.errorHandler" },
        TRACE_DATA_TYPE_ENUM.error
      );
    } catch (error) {
      console.log("error: ", error);
    }
  };
}


